import { render, staticRenderFns } from "./OrgDetailsAddressCommon.vue?vue&type=template&id=5aa39613&scoped=true&"
import script from "./OrgDetailsAddressCommon.vue?vue&type=script&lang=js&"
export * from "./OrgDetailsAddressCommon.vue?vue&type=script&lang=js&"
import style0 from "./OrgDetailsAddressCommon.vue?vue&type=style&index=0&id=5aa39613&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa39613",
  null
  
)

export default component.exports